import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function ZohoTargetModulePicker({ value, onChange, modules }) {
  const moduleNames = Object.keys(modules || {});
  const selectedFields = value !== 'none' && modules ? modules[value] : null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <Label className="text-sm shrink-0">Target Module</Label>
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="w-52 h-8" data-testid="target-module-select">
            <SelectValue placeholder="No target (store only)" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">None (store submissions only)</SelectItem>
            {moduleNames.map(function(m) {
              return <SelectItem key={m} value={m} className="capitalize">{m}</SelectItem>;
            })}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">Mapped submissions will create records in this module automatically.</p>
      </div>
      {selectedFields && (
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="text-xs text-muted-foreground mr-1">Available fields:</span>
          {selectedFields.map(function(f) {
            return <code key={f.field} className="text-[11px] bg-muted px-1.5 py-0.5 rounded font-mono" title={f.label}>{f.field}</code>;
          })}
        </div>
      )}
    </div>
  );
}
